module.exports = __webpack_public_path__ + "static/media/loading6.4c140210.gif";